// The catalog tables' search (Workflows, Task types, Skills): what is typed shows at once, and
// after a short pause it becomes the URL's `q`, which the page sends to the API.
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router";

export const SEARCH_DEBOUNCE_MS = 250;

/** The URL's trimmed `q` and a setter that debounces typing into it, keeping other params. */
export function useUrlSearch(): { text: string; setText: (t: string) => void; q: string } {
  const [params, setParams] = useSearchParams();
  const q = (params.get("q") ?? "").trim();
  const [text, setText] = useState(params.get("q") ?? "");

  useEffect(() => {
    if (text.trim() === q) return;
    const timer = setTimeout(() => {
      setParams(
        (current) => {
          const next = new URLSearchParams(current);
          if (text.trim()) next.set("q", text.trim());
          else next.delete("q");
          return next;
        },
        { replace: true },
      );
    }, SEARCH_DEBOUNCE_MS);
    return () => clearTimeout(timer);
  }, [text, q, setParams]);

  return { text, setText, q };
}
